import { observable, computed, action, makeObservable /*, toJS*/ } from "mobx";

class SearchStore {
  constructor() {
    makeObservable(this);
  }

  /*********************/
  /* 매장 로그인 정보 관리 */
  /*********************/
  //'saleDate' : '20190415' , '20211026'
  /**
   * 매장정보
   * @type {{shopAddr: string, user_name: string, tk: string, saleDate: string, shopCd: string, connPosNo: string}}
   * @private
   */
  @observable
  _st_session = {
    shopCd: "",
    saleDate: "",
    connPosNo: "",
    shopNm: "",
    shopAddr: "",
    tk: "",
    expires_in: "",
    user_name: "",
    profile: "",
    viewType: "",
    viewOrder: "",
    deliveryDfTime: "",
    cookingDfTime: "",
    autoAcceptFlag: "N",
    soundSetting: {
      basicAlarm: "",
      newAlarm: "",
      sendAlarm: "",
      cookingAlarm: "",
      pickupAlarm: "",
      startToPickupLocationAlarm: "",
      unallocatedAlarm: "",
      deliveryAlarm: "",
      naverAlarm: "",
      baeminAlarm: "",
      baemin1Alarm: "",
      baeminStoreAlarm: "",
      baeminPickAlarm: "",
      baeminShopAlarm: "",
      ygyDlvAlarm: "",
      ygyPickAlarm: "",
      ygyShopAlarm: "",
      ygyExpress: "",
      callAlarm: "",
      pandaDlvAlarm: "",
      pandaPickupAlarm: "",
      pandaSelfAlarm: "",
      oltteaahAlarm: "",
      wmpoAlarm: "",
      ddangyoDlvAlarm: "",
      ddangyoPickAlarm: "",
      ddangbaedalAlarm: "",
      naverConnectAlarm: "",
      mukkebiDlvAlarm: "",
      mukkebiPickAlarm: "",
      kioskPickAlarm: "",
      kioskShopAlarm: "",
      posOrderAlarm: "",
      tableOrderAlarm: "",
      qrOrderAlarm: "",
      soundLevel: "",
    },
    managerSetting: {
      realTime: "N",
      salePage: "N",
      orderEnd: "N",
    },
    printerSetting: {
      usedComPortForHooking: "",
      kitchenPrinterFlag: "",
      hookingFlag: "",
      outPrinterFlag: "",
      kitchenPrinterType: "",
      availableComPorts: [],
      kitchenPrinterSettings: [],
      usedKitchenPrinterCodes: [],
      etcPrinterFlag: "",
      etcKitchenPrinterFlag: "",
      usedVirtualModeFlag: "",
      usedVirtualModePrintPort: "",
      usedVirtualModePrintBaudrate: "",
      usedVirtualModeVPrint1: "",
      usedVirtualModeVPrint2: "",
      usedVirtualModeExceptPrint: "",
    },
    etcPrintSettings: {
      defaultPrintSettings: [],
      addPrintSettings: [],
    },
    initView: "",
    kioskOrderYn: "",
    posOrderYn: "",
    dcOrderYn: "",

    pagerBellYn: "",
    posAlarmtalkYn: "",
    alarmTalkYn: "",
    qrAlarmtalkYn: "",
  };

  /**
   * 매장정보 전체 조회
   * @returns {{saleDate: string, shopCd: string}}
   */
  @computed
  get getSession() {
    return this._st_session;
  }

  /**
   * 매장코드 조회
   * @returns {string}
   */
  get getShopCd() {
    return this._st_session.shopCd;
  }

  get getPosNo() {
    return this._st_session.connPosNo;
  }

  /**
   * 개점일자 조회
   * @returns {string}
   */
  get getSaleDate() {
    return this._st_session.saleDate;
  }

  /**
   * 토큰 조회
   * @returns {string}
   */
  get getToken() {
    return this._st_session.tk;
  }

  get getTokenExpireIn() {
    return this._st_session.expires_in;
  }

  /**
   * api통신용 camel_case 응답
   * @returns {{saleDate: string, shopCd: string}}
   */
  @computed
  get getShopCdSaleDate() {
    return {
      shopCd: this._st_session.shopCd,
      saleDate: this._st_session.saleDate,
    };
  }

  @action
  setStSession(data) {
    this._st_session = data;
  }

  @action
  setStSessionShopCd(shopCd, user_name) {
    this._st_session = { ...this._st_session, shopCd: shopCd, user_name: user_name };
  }

  @action
  setStSessionToken(token) {
    this._st_session = { ...this._st_session, tk: token };
  }

  @action
  setStSessionExpireIn(expireIn) {
    this._st_session = { ...this._st_session, expires_in: expireIn };
  }

  @action
  setSessionKey(key, value) {
    this._st_session = { ...this._st_session, [key]: value };
  }

  /*********************/
  /* 좌측 검색 상태 관리  */
  /*********************/
  /**
   * 좌측 상태 현재 값 전체(all), 배달(delivery), 포장(pickup), 테이블(table)
   * @type {string}
   * @private
   */
  @observable
  _st_curr_order_type = "all";

  /**
   * 좌측 상태 설정된 값 조회
   * @returns {string}
   */
  @computed
  get getCurrOrderType() {
    return this._st_curr_order_type;
  }

  /**
   * 좌측 상태 설정된 값 셋팅
   * @param type
   */
  @action
  setCurrOrderType(type) {
    this._st_curr_order_type = type;
  }

  /**
   * 좌측 상태별 조회 카운트 all : 전체, delivery : 배달 , pickup : 포장 , table : 테이블
   * @type {{all: number, delivery: number, pickup: number, table: number}}
   * @private
   */
  @observable
  _st_order_type_obj = {
    all: 0,
    delivery: 0,
    pickupAndTable: 0,
    table: 0,
  };

  /**
   * 좌측 상태별 조회 카운트 리턴
   * @returns {{all: number, delivery: number, pickup: number, table: number}}
   */
  get getOrderTypeObj() {
    return this._st_order_type_obj;
  }

  /**
   * 좌측 상태 원하는 항목 카운트만 리턴
   * @param key
   * @returns {*}
   */
  getOrderTypeObjCount(key) {
    return this._st_order_type_obj[key];
  }

  /**
   * 좌측 상태목록 다시 셋팅
   * @param obj
   */
  @action
  setOrderTypeObj(obj) {
    this._st_order_type_obj = obj;
  }

  //상단탭주문건 완료/취소
  @observable
  _st_end_order_type_obj = {
    all: 0,
    delivery: 0,
    pickupAndTable: 0,
  };

  /**
   *상단탭주문건 완료/취소
   */
  get getEndOrderTypeObj() {
    return this._st_end_order_type_obj;
  }

  /**
   * 상단탭주문건 완료/취소
   * @param obj
   */
  @action
  setEndOrderTypeObj(obj) {
    this._st_end_order_type_obj = obj;
  }

  /*********************/
  /* 상단 검색 상태 관리  */
  /*********************/
  /**
   * 상단 검색 설정된 값  수락전(ready), 처리중(cooking), 전달중(delivery)
   * @type {string}
   * @private
   */
  @observable
  _st_curr_step_type = "ready";

  /**
   * 상단 검색 설정된 값 조회
   * @returns {string}
   */
  @computed
  get getCurrStepType() {
    return this._st_curr_step_type;
  }

  /**
   * 상단 검색 설정값 셋팅
   * @param type
   */
  @action
  setCurrStepType(type) {
    this._st_curr_step_type = type;
  }

  /**
   * 상단 상태 상태별 조회 카운트 ready : 주문수락전, cooking : 매장 처리중 ,  delivery : 상품 전달중
   * @type {{delivery: number, ready: number, cooking: number}}
   * @private
   */
  @observable
  _st_step_type_obj = {
    all: 0,
    ready: 0,
    cooking: 0,
    delivery: 0,
  };

  /**
   * 상단 상태 항목별 카운트 조회
   * @returns {{delivery: number, ready: number, cooking: number}}
   */
  get getStepTypeObj() {
    return this._st_step_type_obj;
  }

  /**
   * 상단 상태 원하는 항목만 카운트
   * @param key
   * @returns {*}
   */
  getStepTypeObjCount(key) {
    return this._st_step_type_obj[key];
  }

  /**
   * 상단 상태 항목별 카운트 전체 재설정
   * @param obj
   */
  @action
  setStepTypeObj(obj) {
    this._st_step_type_obj = obj;
  }

  /**
   * 리스트 검색 영역 활성화
   * @type {boolean}
   * @private
   */
  @observable
  _st_search_bar_bl = false;

  @action
  setSearchBarBl(flag) {
    this._st_search_bar_bl = flag;
  }

  @action
  toggleSearchBarBl() {
    this._st_search_bar_bl = !this._st_search_bar_bl;
  }

  get getSearchBarBl() {
    return this._st_search_bar_bl;
  }

  /**
   * 검색영역 클릭 시 하단 검색 문구 노출
   * @type {boolean}
   * @private
   */
  @observable
  _st_order_search_no_data_view = false;

  @computed
  get getOrderSearchNoDataView() {
    return this._st_order_search_no_data_view;
  }

  @action
  setOrderSearchNoDataView(bl) {
    this._st_order_search_no_data_view = bl;
  }

  /**
   * 검색 키값
   * @type {string}
   * @private
   */
  @observable
  _st_search_key = {
    key: "mobileOrderNo",
    val: "채널 주문번호",
  };

  @computed
  get getSearchKey() {
    return this._st_search_key;
  }

  @action
  setSearchKey(key, val) {
    this._st_search_key = { key: key, val: val };
  }

  @action
  initSearchKey(key, val) {
    this._st_search_key = {
      key: "mobileOrderNo",
      val: "채널 주문번호",
    };
  }

  /**
   * 리스트 검색어
   * @type {string}
   * @private
   */
  @observable
  _st_search_val = "";

  @action
  setSearchVal(val) {
    this._st_search_val = val;
  }

  get getSearchVal() {
    return this._st_search_val;
  }

  /**
   * 검색 키값 내역 레이어 열고 닫기
   * @type {boolean}
   * @private
   */
  @observable
  _st_order_search_view = false;

  @computed
  get getOrderSearchView() {
    return this._st_order_search_view;
  }

  @action
  setOrderSearchView(bl) {
    this._st_order_search_view = bl;
  }

  @action
  setToggleOrderSearchView() {
    this._st_order_search_view = !this._st_order_search_view;
  }

  /**
   * 검색어 입력, 데이터 없습니다 구분 ( SEARCH, NO_DATA )
   * @type {string}
   * @private
   */
  @observable
  _st_search_no_data_val = "";

  @action
  setSearchNoDataVal(val) {
    this._st_search_no_data_val = val;
  }

  get getSearchNoDataVal() {
    return this._st_search_no_data_val;
  }

  //프린터 추가 출력 속도 select box
  @observable
  _st_print_add_select_baudrate = ["4800", "9600", "14400", "19200", "38400", "57600", "115200"];

  get getPrintAddSelectBaudRate() {
    return this._st_print_add_select_baudrate;
  }

  //프린터 추가 select box 팝업
  @observable
  _st_print_add_select = {
    title: "",
    portCheck: "0",
    baudRateCheck: "0",
    list: [],
  };

  get getPrintAddSelectVal() {
    return this._st_print_add_select;
  }

  @action
  setPrintAddSelectVal(key, value) {
    this._st_print_add_select = { ...this._st_print_add_select, [key]: value };
  }

  @observable
  naverUniqueId = localStorage.getItem("naverUniqueId") || "";

  get getNaverUniqueId() {
    return this.naverUniqueId;
  }

  @action
  setNaverUniqueId(uniqueId) {
    this.naverUniqueId = uniqueId;
    if (uniqueId) {
      localStorage.setItem("naverUniqueId", uniqueId);
    } else {
      localStorage.removeItem("naverUniqueId");
    }
  }
}

export default new SearchStore();
